import { fetchApi } from "../../api/apiBase";

export const competitionServiceFactory = () => {
    const getStages = () => fetchApi(`/competitionstages?_sort=id:asc`);

    const getCompetitionContact = () => fetchApi(`/competitioncontacts`);

    return { getStages, getCompetitionContact };
};
